import React, { useState } from "react";
import { BOM } from "../../../../services/definedMethod";
import {
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Tooltip,
} from "antd";

const { Text, Title } = Typography;

const SettingsForm = (props) => {
  const [repaymentPeriod, setRepaymentPeriod] = useState();
  const [
    interestRecalculationCompounding,
    setInterestRecalculationCompounding,
  ] = useState(false);
  const [recalculationRestFrequency, setRecalculationRestFrequency] =
    useState(false);
  const [weeklyRecalculateFrequency, setWeeklyRecalculateFrequency] =
    useState(false);
  const [monthlyRecalculateFrequency, setMonthlyRecalculateFrequency] =
    useState(false);

  const {
    variableInstallmentsChecked,
    recalculateInterestCheck,
    multipleDisbursalsCheck,
    guaranteeRequirementsCheck,
    interestRecalculationFrequencyTypeOptions,
    isEqualAmortization,
    handleAllowPartialPeriodInterestCalcualtion,
    allowPartialPeriodInterestCalcualtion,
    handleCanUseForTopup,
    handleCanDefineInstallmentAmount,
    canDefineInstallmentAmount,
    handleAccountMovesOutOfNPAOnlyOnArrearsCompletion,
    accountMovesOutOfNPAOnlyOnArrearsCompletion,
    handleAllowVariableInstallments,
    allowVariableInstallments,
    interestRecalculationDayOfWeekTypeOptions,
    canUseForTopup,
    handleIsInterestRecalculationEnabled,
    isInterestRecalculationEnabled,
    handleIsArrearsBasedOnOriginalSchedule,
    isArrearsBasedOnOriginalSchedule,
    handleHoldGuaranteeFunds,
    holdGuaranteeFunds,
    handleMultiDisburseLoan,
    multiDisburseLoan,
    interestCalculationPeriodTypeData,
    interestRecalculationNthDayTypeOptions,
    handleIsEqualAmortization,
    handleAllowAttributeConfiguration,
    allowAttributeConfiguration,
    handleGraceOnArrearsAging,
    handleInterestCalcPeriod,
    handleRepaymentFrequency,
    handleGraceOnPrincipalAndInterest,
    handleInterestMethod,
    handleTransactionProcessingStrategy,
    handleArrearsTolerance,
    handleAmortization,
    amortization,
    transactionProcessingStrategy,
    arrearsTolerance,
    graceOnPrincipalAndInterest,
    interestMethod,
    interestCalcPeriod,
    repaymentFrequency,
    graceOnArrearsAging,
  } = props;

  function onRepaymentPeriodSelect(idParam) {
    if (idParam === 1) {
      setRepaymentPeriod(true);
    } else {
      setRepaymentPeriod(false);
    }
  }

  const handleInterestRecalculationCompounding = (param) => {
    if (param === 1 || param === 2 || param === 3) {
      setInterestRecalculationCompounding(true);
    } else {
      setInterestRecalculationCompounding(false);
    }
  };

  const handleRecalculationRestFrequency = (param) => {
    if (param === 2 || param === 3 || param === 4 || param === null) {
      setRecalculationRestFrequency(false);
    } else {
      setRecalculationRestFrequency(true);
    }

    if (param === 3) {
      setWeeklyRecalculateFrequency(true);
    } else {
      setWeeklyRecalculateFrequency(false);
    }

    if (param === 4) {
      setMonthlyRecalculateFrequency(true);
    } else {
      setMonthlyRecalculateFrequency(false);
    }
  };

  return (
    <Form
      layout="vertical"
      onFinish={props.onFinish}
      form={props.form}
      initialValues={props.initialValues}
      style={{ margin: 30 }}
    >
      <Row style={{ justifyContent: "space-between" }}>
        <Divider orientation="left" orientationMargin="0">
          General Information
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Amortization</Text>}
            name={"amortizationType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              options={props.amortizationData}
              placeholder="Please select a value"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Interest Method</Text>}
            name={"interestType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              options={props.interestTypeData}
              placeholder="Please select a value"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={"Is Equal Amortization"} name="isEqualAmortization">
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleIsEqualAmortization}
              value={isEqualAmortization}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Interest Calculation Period</Text>}
            name={"interestCalculationPeriodType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              options={interestCalculationPeriodTypeData}
              placeholder="Please select a value"
              onChange={onRepaymentPeriodSelect}
            />
          </Form.Item>
        </Col>
        {repaymentPeriod && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip
                    title={
                      "Calculate interest for exact days in partial period"
                    }
                  >
                    {BOM.SubstringFormat(
                      "Calculate interest for exact days in partial period",
                      25
                    )}
                  </Tooltip>
                }
                name="allowPartialPeriodInterestCalcualtion"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>
          </>
        )}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Repayment Strategy</Text>}
            name={"transactionProcessingStrategyId"}
            rules={[{ required: true, message: "Required Field" }]}
          >
            <Select
              options={props.transactionProcessingStrategyOptions}
              placeholder="Please select a value"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Moratorium</Text>}
            name={"graceOnPrincipalPayment"}
          >
            <Input placeholder="On Principal Payment" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Grace On Interest Payment</Text>}
            name={"graceOnInterestPayment"}
          >
            <Input placeholder="On Interest Payment" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Interest Free Period</Text>}
            name={"graceOnInterestCharged"}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Arrears Tolerance</Text>}
            name={"inArrearsTolerance"}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Days In Year</Text>}
            name={"daysInYearType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              options={props.daysInYearData}
              placeholder="Please select a value"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Days In Month</Text>}
            name={"daysInMonthType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              options={props.daysInMonthData}
              placeholder="Please select a value"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Allow Fixing Of The Installment Amount"}
            name="canDefineInstallmentAmount"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              value={canDefineInstallmentAmount}
              onChange={handleCanDefineInstallmentAmount}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip
                title={
                  "Number of days a loan may be overdue before moving into arrears"
                }
              >
                {BOM.SubstringFormat(
                  "Number of days a loan may be overdue before moving into arrears",
                  25
                )}
              </Tooltip>
            }
            name={"graceOnArrearsAgeing"}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip
                title={
                  "Maximum number of days a loan may be overdue before becoming a NPA (non performing asset)"
                }
              >
                {BOM.SubstringFormat(
                  "Maximum number of days a loan may be overdue before becoming a NPA (non performing asset)",
                  25
                )}
              </Tooltip>
            }
            name={"overdueDaysForNPA"}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip
                title={
                  "Account moves out of NPA only after all arrears have been cleared?"
                }
              >
                {BOM.SubstringFormat(
                  "Account moves out of NPA only after all arrears have been cleared?",
                  25
                )}
              </Tooltip>
            }
            name="accountMovesOutOfNPAOnlyOnArrearsCompletion"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              value={accountMovesOutOfNPAOnlyOnArrearsCompletion}
              onChange={handleAccountMovesOutOfNPAOnlyOnArrearsCompletion}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Principal Threshold (%) for Last Installment</Text>}
            name={"principalThresholdForLastInstallment"}
          >
            <Input placeholder="Please enter a value" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Is Variable Installments Allowed?"}
            name="allowVariableInstallments"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleAllowVariableInstallments}
              value={variableInstallmentsChecked}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        {variableInstallmentsChecked && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Variable Installments</Text>}
                name={"minimumGap"}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Minimum gap between" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text hidden>Variable Installments</Text>}
                name={"maximumGap"}
              >
                <Input placeholder="Maximum gap between" />
              </Form.Item>
            </Col>
          </>
        )}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip
                title={"Is allowed to be used for providing Topup Loans?"}
              >
                {BOM.SubstringFormat(
                  "Is allowed to be used for providing Topup Loans?",
                  25
                )}
              </Tooltip>
            }
            name="canUseForTopup"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              value={canUseForTopup}
              onChange={handleCanUseForTopup}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}></Col>

        <Divider orientation="left" orientationMargin="0">
          Interest Recalculation
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Recalculate Interest"}
            name="isInterestRecalculationEnabled"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleIsInterestRecalculationEnabled}
              value={recalculateInterestCheck}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        {recalculateInterestCheck ? (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Pre-closure interest calculation rule</Text>}
                name={"preClosureInterestCalculationStrategy"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={props.preClosureInterestCalculationStrategy}
                  placeholder="Please select a value"
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Advance payments adjustment type</Text>}
                name={"rescheduleStrategyMethod"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={props.rescheduleStrategyType}
                  placeholder="Please select a value"
                />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Interest recalculation compounding on</Text>}
                name={"interestRecalculationCompoundingMethod"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={props.interestRecalculationCompoundingType}
                  placeholder="Please select a value"
                  onChange={handleInterestRecalculationCompounding}
                />
              </Form.Item>
            </Col>

            {interestRecalculationCompounding && (
              <>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Frequency for compounding</Text>}
                    name={"recalculationCompoundingFrequencyType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={interestRecalculationFrequencyTypeOptions}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text>Frequency Interval for compounding</Text>}
                    name={"recalculationCompoundingFrequencyInterval"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Input placeholder="Please enter a value" />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip
                    title={"Frequency for recalculate Outstanding Principal"}
                  >
                    {BOM.SubstringFormat(
                      "Frequency for recalculate Outstanding Principal",
                      25
                    )}
                  </Tooltip>
                }
                name={"recalculationRestFrequencyType"}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Select
                  options={props.recalculationRestFrequencyType}
                  placeholder="Please select a value"
                  onChange={handleRecalculationRestFrequency}
                />
              </Form.Item>
            </Col>

            {weeklyRecalculateFrequency && (
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={"Recalculation Frequency Day Of Week"}
                  name={"recalculationRestFrequencyDayOfWeekType"}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    options={interestRecalculationDayOfWeekTypeOptions}
                    placeholder="Please select a value"
                  />
                </Form.Item>
              </Col>
            )}

            {monthlyRecalculateFrequency && (
              <>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Recalculation Frequency Day"}
                    name={"recalculationRestFrequencyNthDayType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={interestRecalculationNthDayTypeOptions}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={"Recalculation Frequency Day Of Week"}
                    name={"recalculationRestFrequencyDayOfWeekType"}
                    rules={[
                      {
                        required: true,
                        message: "Required Field",
                      },
                    ]}
                  >
                    <Select
                      options={interestRecalculationDayOfWeekTypeOptions}
                      placeholder="Please select a value"
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Frequency Interval for recalculation</Text>}
                name={"recalculationRestFrequencyInterval"}
                hidden={recalculationRestFrequency}
                rules={[
                  {
                    required: true,
                    message: "Required Field",
                  },
                ]}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip
                    title={
                      "Is Arrears recognization based on original schedule"
                    }
                  >
                    {BOM.SubstringFormat(
                      "Is Arrears recognization based on original schedule",
                      25
                    )}
                  </Tooltip>
                }
                name="isArrearsBasedOnOriginalSchedule"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleIsArrearsBasedOnOriginalSchedule}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>
          </>
        ) : null}

        <Divider orientation="left" orientationMargin="0">
          Guarantee Requirements
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Place Guarantee Funds On-Hold?"}
            name="holdGuaranteeFunds"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleHoldGuaranteeFunds}
              value={guaranteeRequirementsCheck}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        {guaranteeRequirementsCheck ? (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Mandatory Guarantee(%)</Text>}
                name={"mandatoryGuarantee"}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Guarantee from Own Funds(%)</Text>}
                name={"minimumGuaranteeFromOwnFunds"}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Minimum Guarantee from Guarantors Funds(%)</Text>}
                name={"minimumGuaranteeFromGuarantor"}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Please enter a value" />
              </Form.Item>
            </Col>
          </>
        ) : null}

        <Divider orientation="left" orientationMargin="0">
          Configurable Terms and Settings
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip
                title={
                  "Allow overriding select terms and settings in loan accounts"
                }
              >
                {BOM.SubstringFormat(
                  "Allow overriding select terms and settings in loan accounts",
                  25
                )}
              </Tooltip>
            }
            name="allowAttributeConfiguration"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleAllowAttributeConfiguration}
              value={allowAttributeConfiguration}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        {allowAttributeConfiguration ? (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={"Amortization"} name="amortization">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleAmortization}
                  value={amortization}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={"Repayment strategy"}
                name="transactionProcessingStrategy"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleTransactionProcessingStrategy}
                  value={transactionProcessingStrategy}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={"Arrears Tolerance"} name="arrearsTolerance">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleArrearsTolerance}
                  value={arrearsTolerance}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={"Moratarium"}
                name="graceOnPrincipalAndInterest"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleGraceOnPrincipalAndInterest}
                  value={graceOnPrincipalAndInterest}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={"Interest Method"} name="interestMethod">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleInterestMethod}
                  value={interestMethod}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={"Interest Calculation Period"}
                name="interestCalcPeriod"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleInterestCalcPeriod}
                  value={interestCalcPeriod}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={"Repaid every"} name="repaymentFrequency">
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleRepaymentFrequency}
                  value={repaymentFrequency}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Tooltip
                    title={
                      "Number of days a loan may be overdue before moving into arrears"
                    }
                  >
                    {BOM.SubstringFormat(
                      "Number of days a loan may be overdue before moving into arrears",
                      25
                    )}
                  </Tooltip>
                }
                name="graceOnArrearsAging"
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    `${"Option"}`,
                    "select"
                  )}
                  options={[
                    { value: true, label: "Yes" },
                    { value: false, label: "No" },
                  ]}
                  onChange={handleGraceOnArrearsAging}
                  value={graceOnArrearsAging}
                  showSearch
                />{" "}
              </Form.Item>
            </Col>
          </>
        ) : null}

        <Divider orientation="left" orientationMargin="0">
          Loan Tranche Details
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={"Enable Multiple Disbursals "}
            name="multiDisburseLoan"
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(`${"Option"}`, "select")}
              options={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              onChange={handleMultiDisburseLoan}
              value={multipleDisbursalsCheck}
              showSearch
            />{" "}
          </Form.Item>
        </Col>

        {multipleDisbursalsCheck ? (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximum Tranche count </Text>}
                name={"maxTrancheCount"}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>Maximum allowed outstanding balance</Text>}
                name={"outstandingLoanBalance"}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </>
        ) : null}
      </Row>
    </Form>
  );
};

export default SettingsForm;
